import { Car, ScanEye, ShieldCheck, Server, Moon, Save } from 'lucide-react';
import SeriesTemplate from '../components/SeriesTemplate';

const LprCamera = () => {
  const features = [
    {
      Icon: Car,
      title: 'ナンバー確認に適した設計',
      desc: '車両出入口などで、ナンバーの数字・英字を確認したい場合に向いた設計です。',
    },
    {
      Icon: ScanEye,
      title: '人・車両検知',
      desc: '車両の通過を検知し、必要な確認や録画管理をサポートします。',
    },
    {
      Icon: Moon,
      title: '夜間・暗所にも対応',
      desc: '赤外線対応モデルにより、夜間の車両出入口でも確認しやすくなります。',
    },
    {
      Icon: ShieldCheck,
      title: '屋外設置に対応',
      desc: 'IP66対応モデルがあり、屋外の車両出入口・駐車場などに設置できます。',
    },
    {
      Icon: Server,
      title: 'NVR・録画機器と連携',
      desc: 'ナンバー確認用の映像を、通常の防犯映像と組み合わせて記録できます。',
    },
    {
      Icon: Save,
      title: 'microSD対応',
      desc: '本体側でのバックアップ録画にも対応するモデルがあります。',
    },
  ];

  const notes = [
    'LPRカメラは「ナンバーの数字・英字を確認しやすくする」ためのカメラです。自動読み取り(OCR)が確実に動作することを保証するものではありません。',
    '設置環境、撮影角度、明るさ、車両の速度などにより、確認できる内容は異なります。',
    'ヘッドライトの反射、逆光、雨・雪などの影響を受けやすいため、設置場所の事前確認が重要です。',
    '屋外設置の場合は、配線経路・取付位置・防水処理の確認が必要です。',
    '機種や設定内容により、使用できる機能が異なる場合があります。',
  ];

  return (
    <SeriesTemplate
      id="lpr"
      eyebrow="LPR CAMERA"
      name="LPRカメラシリーズ"
      description="車両出入口などで、ナンバーの数字・英字を確認したい場合に適したカメラシリーズです。駐車場・施設入口・車両の出入り確認などに向いています。"
      tags={['LPR対応', '8MP', 'PoE対応', 'IP66', '赤外線', '遠隔確認']}
      heroImage="/images/lpr-camera.png"
      features={features}
      locations={['車両出入口', '施設入口', '駐車場入口', '車両の出入り確認', '荷捌き場', '工場出入口']}
      notes={notes}
    />
  );
};

export default LprCamera;
